<template>
  <el-dialog
    :visible="terminalVisibleProp"
    @opened="doOpened"
    @open="doOpen"
    @close="doClose"
    fullscreen
    custom-class="xterm-dialog"
  >
    <div id="terminal-container" ref="terminal" />
  </el-dialog>
</template>

<script>
import { Terminal } from "xterm";
import "xterm/css/xterm.css";
import { FitAddon } from "xterm-addon-fit";
// import { AttachAddon } from 'xterm-addon-attach';
import { Base64 } from "js-base64";

export default {
  data() {
    return {
      term: null,
      websocket: null,
      fitAddon: null,
    };
  },
  props: {
    obj: { username: "", password: "", port: Number, protocol: "" },
    terminalVisibleProp: Boolean,
  },
  // beforeDestroy() {
  //   this.terminalSocket.close();
  //   this.term.destroy();
  //   // beforeDestroy（对象准备死掉）
  //   // 就在Vue对象被破坏并从内存中释放之前， beforeDestroy 钩子被触发
  // },
  methods: {
    doOpen() {},
    resizeScreen(term, websocket) {
      window.onresize = () => {
        this.fitAddon.fit();
        websocket.send(
          JSON.stringify({
            type: "resize",
            rows: term.rows,
            cols: term.cols,
          })
        );
      };
    },
    doOpened() {
      this.term = new Terminal({
        cursorBlink: true, // 光标闪烁
      });
      this.fitAddon = new FitAddon();
      this.term.loadAddon(this.fitAddon);
      // const terminalContainer = document.getElementById('terminal-container');
      // this.term.open(terminalContainer);
      this.term.open(this.$refs.terminal);
      this.fitAddon.fit(); // 初始化窗口大小
      this.term.focus();
      this.initWebSocket();
      this.resizeScreen(this.term, this.websocket);
      // this.cmdTerminal(this.term, this.websocket);
      // this.bindTerminal(this.term, this.websocket, true, -1);
    },
    initWebSocket() {
      // 初始化weosocket
      // const wsuri = `ws://${window.location.host}/ws/${this.obj.protocol}?cols=${this.term.cols}&rows=${this.term.rows}`
      //   + `&username=${this.obj.username}&password=${this.obj.password}&port=${this.obj.port}&host=localhost`;
      const wsuri =
        `${location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws/${this.obj.protocol}?cols=${this.term.cols}&rows=${this.term.rows}` +
        `&username=${this.obj.username}&password=${this.obj.password}&port=${this.obj.port}&host=106.14.169.68`;
// console.log(wsuri)
      // `Bearer ${window.localStorage.getItem('jwtToken')}`
      this.websocket = new WebSocket(wsuri);
      // const attachAddon = new AttachAddon(this.websocket);
      // this.term.loadAddon(attachAddon);
      this.websocket.onmessage = this.websocketonmessage;
      this.websocket.onopen = this.websocketonopen;
      this.websocket.onerror = this.websocketonerror;
      this.websocket.onclose = this.websocketclose;
      this.term.onData((data) => this.websocketsend(data));
    },
    websocketonopen() {
      // 连接建立之后执行send方法发送数据
      // console.log('连接成功', this.websocket.readyState);
    },
    websocketonerror() {
      // 连接建立失败重连
      this.$message.error("websocket 建立连接失败");
      this.doClose();
    },
    websocketonmessage(ev) {
      // 数据接收
      this.term.write(ev.data);
    },
    websocketsend(Data) {
      // 数据发送
      this.websocket.send(
        JSON.stringify({
          type: "cmd",
          cmd: Base64.encode(Data), // encode data as base64 format
        })
      );
    },
    websocketclose() {
      // 关闭
      this.$message.error("websocket 连接关闭");
      this.doClose();
    },
    // cmdTerminal(term, websocket) {
    //   const ws = websocket;
    //   const handleTerminalData = (data) => {
    //     ws.send(
    //       JSON.stringify({
    //         type: 'cmd',
    //         cmd: Base64.encode(data), // encode data as base64 format
    //       })
    //     );
    //   };
    //   const handleWebSocketMessage = (ev) => {
    //     term.write(ev.data);
    //   };
    //   term.onData(data => handleTerminalData(data));
    //   ws.onmessage = handleWebSocketMessage;
    // },
    doClose() {
      if (this.websocket) {
        this.websocket.close();
      }
      if (this.term) {
        this.term.dispose();
      }
      this.$emit("update:terminalVisibleProp", false);
    },
  },
};
</script>

<style lang="scss">
.xterm-dialog {
  background-color: black !important;
  .el-dialog__headerbtn i {
    font-size: 25px;
  }
  #terminal-container {
    // margin-top: 1rem;
    height: calc(100vh - 150px) !important;
  }
}
</style>
